"use client";

import { useHeld } from "@/hooks/use-held";
import type { EventRowsView } from "@/lib/odds-screen/live/types";

export type HeldView<V> = { readonly view: V; readonly heldAtMs: number | null };

export function useHeldView<V extends EventRowsView<unknown>>(live: V, enabled: boolean, key: string): HeldView<V> {
  const { value, heldAtMs } = useHeld(live, enabled, key, live.phase === "live" && live.pending === 0);
  return { view: value, heldAtMs };
}
